import React from "react";
import "./EditBoxIcon.scss"

function EditBoxIcon() {
  return (
    <span className="anticon ant-editbox">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 19 19"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="#0096dc" fillRule="nonzero" transform="translate(-427 -663)">
            <g transform="translate(419 214)">
              <g transform="translate(0 434)">
                <g transform="translate(8 15)">
                  <path d="M13.5 11.25a.9.9 0 011.8 0v5.063a2.587 2.587 0 01-2.587 2.587H2.587A2.587 2.587 0 010 16.313V6.187A2.587 2.587 0 012.587 3.6h5.485a.9.9 0 010 1.8H2.587a.787.787 0 00-.787.787v10.126c0 .434.353.787.787.787h10.126a.787.787 0 00.787-.787V11.25z"></path>
                  <path
                    d="M10.126 2.048l.017 9.536.9 1.35.9-1.349-.017-9.537h-1.8zm-.902-1.8h3.6a.9.9 0 01.9.899l.02 10.708a.9.9 0 01-.152.501l-1.8 2.7a.9.9 0 01-1.497 0l-1.8-2.7a.9.9 0 01-.152-.498L8.324 1.15a.9.9 0 01.9-.902z"
                    transform="rotate(45 11.034 7.853)"
                  ></path>
                  <path d="M11.5136039 4.6863961L12.7863961 3.4136039 15.4863961 6.1136039 14.2136039 7.3863961z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default EditBoxIcon;
